<template>
    <div class="top">
        <div class="max-w-screen-md mx-auto h-full flex flex-col items-center justify-center px-4">
            <AnimatedElement animation="animate__fadeInUp">
                <p class="text-2xl lg:text-4xl text-white text-center leading-normal lg:leading-normal">Welcome to Flower Shop – Bringing Nature's Beauty to You! Fresh Flowers, Unique Bouquets, and Love in Every Petal</p>
            </AnimatedElement>

            <div class="pt-8">
                <AnimatedElement animation="animate__fadeInUp" style="animation-delay: 0.2s">
                    <p class="bg-rose-600 rounded-full text-white px-8 py-4">Contact</p>
                </AnimatedElement>
            </div>
        </div>
    </div>
</template>

<script>
import AnimatedElement from './AnimatedElement.vue';

export default {
    components: {
        AnimatedElement,
    },
};
</script>

<style>
.top {
    height: 100vh;
    min-height: 600px;
    padding-top: 80px;
    background-image: linear-gradient(rgba(0,0,0,0.5), rgba(0,0,0,0.5)),
    url("../assets/images/top.jpg");
    background-size: cover;
    background-position: center center;
}
</style>